import { render, staticRenderFns } from "./vc-rate.vue?vue&type=template&id=eaa22900&scoped=true&"
import script from "./vc-rate.vue?vue&type=script&lang=js&"
export * from "./vc-rate.vue?vue&type=script&lang=js&"
import style0 from "./vc-rate.vue?vue&type=style&index=0&id=eaa22900&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa22900",
  null
  
)

export default component.exports